export const Section1 = {
	heading: 'Make authentic connections through new Beacon Discovery tool',
	para1: {
		content1: 'New Hope Network’s new event, ',
		content2_link: 'Newtopia Now,',
		content3:
			' is coming to Denver, Colorado, on August 25-28. One component of Newtopia that sets it apart from other tradeshows is Conscious Connections, a custom match-making platform powered by ',
		content4_link: 'Beacon Discovery'
	},
	para2: {
		content1: 'A new type of ',
		content2_link: 'trade show',
		content3:
			', Newtopia Now is designed to connect the right brands with the right buyers and the right investors. It will feature workshops, research results, cooking and product demos, buyer opportunities, experiential networking events and more. Using a “show within a show” concept, Newtopia Now features ',
		content4_link: 'four neighborhoods',
		content5: ' with unique themes and atmospheres.'
	},
	para3:
		'Have you heard of Beacon? With more than 100 filters and custom templates based on your ingredient standards, Beacon is fostering a more seamless tradeshow experience for retailers while helping brands stand out and form connections year-round.'
};

export const Section2 = {
	heading: 'How Conscious Connections works',
	para1: {
		content1:
			'For brands exhibiting at Newtopia Now, joining the Beacon Discovery platform is included in your booth package—and it’s a crucial step in driving Conscious Connections. Upon submitting your ',
		content2_link: 'Standards application form',
		content3:
			' and reserving a booth, the New Hope Audience Success Team will help you add products to Beacon Discovery.'
	},
	para2:
		'“The intention behind Newtopia is ‘connection’. With Conscious Connections, we are saving attendees time and fostering new relationships with data from Beacon Discovery,” says Jeena Mathew, New Hope Network’s project management director. ',
	para3:
		'For all Newtopia Now attendees, event registration includes a number of simple questions to help determine what sort of products and services attendees are looking for.',
	para4:
		'All Newtopia Now attendees will also have access to the event app, beginning in July. Once it is live, download it and begin your match-making journey. Using AI and data from Beacon Discovery, attendees will receive custom matches with exhibiting brands visible on the event app. If both parties approve the connection, either party can then initiate a conversation and set up a time to meet in the Connections Lounge in the Represent Neighborhood.',
	para5:
		'Anyone attending Newtopia Now is an eligible connection—for example, brands can connect with brands; service providers can connect with brands; and buyers can connect with brands. Not interested in a connection? Simply decline.'
};

export const Section3 = {
	heading: 'Save time and elevate networking',
	para1:
		'Rather than scroll through an attendee list and spend time researching brands to determine if they would be a good fit, Conscious Connections takes the guess work out of the equation and curates connections based on your needs. In addition to meetings you might plan prior to Newtopia Now, Conscious Connections facilitates and simplifies new conversations: Simply approve a connection and suggest a time to talk. We’ve even solved the problem of finding a meeting spot with our Connections Lounge.',
	li: {
		heading: 'Here are the six steps to make the most of Conscious Connections:',
		l1: {
			content: 'For brands attending Newtopia Now, submit your ',
			content_link: 'Standards Form'
		},
		l2: {
			content1: 'Once your booth is booked, onboard your products to ',
			content2_link: 'Beacon Discovery',
			content3: ' Need assistance? Contact ',
			content4: 'AudienceSuccessTeam@newhope.com.'
		},
		l3: 'Fill out the Newtopia registration questions.',
		l4: 'Download the event app when it goes live in July.',
		l5: 'Browse your custom matches in advance of Newtopia Now. Connect, network, have fun!'
	},
	para2: {
		content1: 'For more information and to register, visit ',
		content2_link: 'www.newtopianow.com',
		content3:
			'. To view a list of brand partners participating in Newtopia Now, to date, visit here.'
	}
};

export enum Links {
	newtopia_now = 'https://www.newtopianow.com/en/home.html',
	beacon_discovery = 'https://beacon.newhope.com/',
	trade_show = 'https://www.newhope.com/newtopia-now/retail-buyers-and-brands-to-chart-the-future-of-conscious-cpg-at-inaugural-newtopia-now-event',
	four_neighbourhoods = 'https://www.newtopianow.com/en/Experience/Experience.html#:~:text=Four%20neighborhoods%2C%20infinite%20discoveries.',
	standard_applications_form = 'https://standards.newhope.com/start-here/'
}

export enum Images {
	jeena_mathews_connection = 'https://s44021.pcdn.co/wp-content/uploads/2024/06/jeena-mathew-connections-pull-quote.webp'
}
